export const IPayloadRepositoryType = Symbol('IPayloadRepository');
